// 단일 API base URL 소스
// - VITE_API_URL이 명시적으로 설정되면 그 값 사용 (CI/CD가 staging/prod에서 '/api' 주입)
// - 없을 때 dev 모드면 localhost 백엔드, prod 모드면 same-origin '/api' fallback
//   → 운영 빌드에서 VITE_API_URL 누락 시에도 localhost로 새지 않음
export const API_BASE_URL: string =
  import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV ? 'http://localhost:3000/api' : '/api');
